import React from 'react';
import { Typography, styled, Theme } from '@material-ui/core';
import {
  getVerifiedFlightDelayLabel,
  getVerifiedFlightDetailsText,
} from '../utils/addressUtils';

interface VerifiedFlightProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  verifiedFlight: any;
  flightTime: Date | null;
  isPrivateFlight?: boolean;
}

const getColorLabel = (delay, cancelled, theme): string => {
  switch (true) {
    case delay > 0:
    case cancelled:
      return theme.palette.error.main;
    case delay < 0:
      return theme.palette.success.main;
    default:
      return 'transparent';
  }
};

const VerifiedFlightDetails: React.FC<VerifiedFlightProps> = ({
  verifiedFlight,
  flightTime,
  isPrivateFlight,
}) => {
  return (
    <Typography variant="caption" color="textSecondary" component="p">
      {getVerifiedFlightDetailsText(
        isPrivateFlight,
        flightTime,
        verifiedFlight,
      )}
      {verifiedFlight?.delay || verifiedFlight?.cancelled ? (
        <DelayLabel
          variant="caption"
          delay={verifiedFlight.delay}
          cancelled={verifiedFlight.cancelled}
        >
          {getVerifiedFlightDelayLabel(
            verifiedFlight?.delay,
            verifiedFlight?.cancelled,
          )}
        </DelayLabel>
      ) : null}
    </Typography>
  );
};

const DelayLabel = styled(Typography)(
  ({
    theme,
    delay,
    cancelled,
  }: {
    theme: Theme;
    delay: number;
    cancelled: number;
  }) => ({
    color: getColorLabel(delay, cancelled, theme),
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: theme.spacing(1),
  }),
);

export default VerifiedFlightDetails;
